/**
 * Traverses a dictionary and calls a callback function on each key-value pair.
 * 
 * The callback may return true or false to indicate whether to traverse the value of the key.
 * 
 * If the callback returns nothing, all object-values will be traversed.
 * 
 * @param {object} obj 
 * @param {function} cb 
 */
export const traverse = async (obj, cb, previous=null, path=[]) => {
	for (const key in obj) {
		const res = await cb(key, obj[key], obj, path.join('.'))
		const continue_ = res === undefined ? true : res

		if (continue_ && typeof obj[key] === 'object') {
			await traverse(obj[key], cb, obj, [...path, key])
		}
	}
}